module.exports = __webpack_public_path__ + "static/media/404.3acf2e3b.svg";